import { useLayoutEffect, useRef, useState, memo } from "react";
import { loadModules } from "esri-loader";
import useEsri from "../hooks/useEsri";
import Collapse from "../components/Collapse";
import { ArrowIcon } from "../components/Icons";

const LegendCard = memo(({ position, customClass }) => {
  const containerRef = useRef();
  const { esriLoader } = useEsri();
  const [isOpen, setIsOpen] = useState(true);

  useLayoutEffect(() => {
    if (!esriLoader) return;
    const modulesToLoad = ["esri/widgets/Legend"];
    loadModules(modulesToLoad).then(([Legend]) => {
      new Legend({
        view: esriLoader.view,
        container: containerRef.current,
      });
    });
  }, [esriLoader]);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className={`absolute rounded shadow-md m-8 bg-white z-10 ${position} ${customClass}`}>
      <div
        role="button"
        className="flex flex-wrap cursor-pointer"
        onClick={toggle}
      >
        <div className="w-4/5 font-bold">
          <h3 className="font-bold text-xl w-64 mt-2 ml-2">Legend</h3>
        </div>

        <div className="w-1/5">
          <ArrowIcon />
        </div>
      </div>
      <Collapse isOpen={isOpen}>
        <section
          data-testid="legend-test"
          className="space-y-2 h-56 min-w-full overflow-auto my-1"
        >
          <div className="esri-layer-legend" ref={containerRef}></div>
        </section>
      </Collapse>
    </div>
  );
});

export default LegendCard;
